import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

export const logAudit = async ({ action, actorUid, actorEmail, targetId, metadata = {} }) => {
    if (!action || !actorUid) return;
    await addDoc(collection(db, 'audit_logs'), {
        action,
        actorUid,
        actorEmail: actorEmail || '',
        targetId: targetId || '',
        metadata,
        createdAt: serverTimestamp(),
    });
};
